import './hireCreditLimit.scss';

import React, { useEffect } from 'react';
import { i18n } from 'core/i18n';
import { formatAmount } from 'utilities/currencyHelper';
import { LoadingSection } from 'commonsComponents/loadingSection';
import OKSliderInput from 'commonsComponents/OKSliderInput';
import { OKMessage } from 'commonsComponents/OKMessage';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import HireCreditLimitModal from 'components/hire/hireCreditLimitModal/hireCreditLimitModal';
import HireNewCreditLimitBanner from './hireNewCreditLimitBanner';
import { EURO_SYMBOL, NOT_MAX_LIMIT } from 'constants/index';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import { recordLinkV2 } from 'utilities/tagging';

const { formatText, getLanguage, FormattedText } = i18n;

const HireNewCreditLimit = ({
    handleCreditLimitChange,
    handleCreditLimitModalValueChange,
    handleModalContinue,
    handleToggleModal,
    immHireCreditLimit,
    immHirePaymentMethod,
    bannerImage,
    isCheckboxChecked,
    changeCreditLimitMessages,
    maximunNotLimit,
    minimumlimit,
    amount,
    disabledSlider,
    maximumLimitNoMessage,
    onChangeSlider,
    getCustomTags,
    pageName = '',
    onOpenSelectMenu,
    onCloseSelectMenu,
    onSelectChange,
}) => {
    const sliderMarks = immHireCreditLimit.get('marks');
    const maximumLimitAuthorize = immHireCreditLimit.get('maximumLimitAuthorize');
    const isFetching = immHireCreditLimit.get('isFetching')
    const maxValue = immHireCreditLimit.get('maxValue');
    const minValue = immHireCreditLimit.get('minValue');
    const title = formatText('hireCreditLimitComponent-creditLimit');
    const minLabel = `${formatText('hireCreditLimitComponent-minLabel')} ${formatAmount(minValue, getLanguage(), 0)}`;
    const maxLabel = `${formatText('hireCreditLimitComponent-maxLabel')} ${formatAmount(maxValue, getLanguage(), 0)}`;

    const creditLimit = !isCheckboxChecked && __CONTACT_CENTER__ && !isPrintOfficeMode() && immHireCreditLimit.get('creditLimit') === NOT_MAX_LIMIT
        ? sliderMarks.get(0)
        : (immHireCreditLimit.get('creditLimit') === NOT_MAX_LIMIT ? sliderMarks.get(0) : immHireCreditLimit.get('creditLimit'));

    return (
        <article className="hire-credit-limit row">
            {isFetching ?
                <LoadingSection /> :
                <section className="hire-credit-limit__slider-container col-xs-12">
                    <h4>{title}</h4>
                    {maximumLimitAuthorize && maximumLimitAuthorize !== NOT_MAX_LIMIT && !maximumLimitNoMessage &&
                        (!__CONTACT_CENTER__ || (__CONTACT_CENTER__ && isPrintOfficeMode())) && (
                            <HireNewCreditLimitBanner
                                bannerImage={bannerImage}
                                maximumLimitAuthorize={maximumLimitAuthorize}
                                changeCreditLimitMessages={changeCreditLimitMessages}
                            />
                        )
                    }
                    <OKSliderInput
                        defaultValue={creditLimit}
                        marks={sliderMarks}
                        maxLabel={maxLabel}
                        minLabel={minLabel}
                        onChange={handleCreditLimitChange}
                        unit={EURO_SYMBOL}
                        disabled={disabledSlider || __CONTACT_CENTER__ && !isPrintOfficeMode() ? maximunNotLimit && Number(minimumlimit) < amount ? false : !isCheckboxChecked : undefined}
                        disabledSelect={disabledSlider}
                        onOpenSelectMenu={onOpenSelectMenu}
                        onCloseSelectMenu={onCloseSelectMenu}
                        onChangeSlider={onChangeSlider}
                        onSelectChange={onSelectChange}
                    />


                    {!maximumLimitNoMessage && (!maximumLimitAuthorize || maximumLimitAuthorize === NOT_MAX_LIMIT) && (
                        (__CONTACT_CENTER__ && !isPrintOfficeMode() && !maximunNotLimit)
                            ? <CcInfoContentNotPreapproved getCustomTags={getCustomTags} pageName={pageName} />
                            : <InfoContentNotPreapproved getCustomTags={getCustomTags} pageName={pageName} changeCreditLimitMessages={changeCreditLimitMessages} />
                    )}

                    <HireCreditLimitModal
                        creditLimit={immHireCreditLimit.get('creditLimit')}
                        creditLimitModalValue={immHireCreditLimit.get('creditLimitModalValue')}
                        immHirePaymentMethod={immHirePaymentMethod}
                        maxValueToAuthorize={immHireCreditLimit.get('maxValueToAuthorize')}
                        onRequestClose={() => handleToggleModal(false)}
                        onRequestContinue={handleModalContinue}
                        openModal={immHireCreditLimit.get('modalIsOpen')}
                        handleCreditLimitModalValueChange={handleCreditLimitModalValueChange}
                    />
                </section>
            }
        </article>
    );
};

const InfoContentNotPreapproved = ({ getCustomTags, pageName, changeCreditLimitMessages }) => {
  useEffect(() => {
    if (getCustomTags) {
      const tag = getCustomTags({ pageName }).showMessageNoLimitPreapproved;
      recordLinkV2(tag);
    }
  }, []);

  return (
    <div
      className={
        'hire-credit-limit__info'
      }
    >
      <OKMessage type={'informative'}>
        <FormattedText
          value={
            changeCreditLimitMessages
              ? 'changeNewCreditLimit-step1InfoNoPreapproved'
              : 'hireNewCreditCard-step1InfoNoPreapproved'
          }
        />
      </OKMessage>
    </div>
  );
};

const CcInfoContentNotPreapproved = ({ getCustomTags, pageName }) => {
  useEffect(() => {
    if (getCustomTags) {
      const tag = getCustomTags({ pageName }).showMessageNoLimitPreapproved;
      recordLinkV2(tag);
    }
  }, []);

  return (
    <div className="hire-credit-limit-cc-info">
      <OKMessage type={'informative'}>
        <FormattedText
          value="cc_hireNewCreditCard-step1InfoNoPreapproved"
          className="informative-text"
        />
      </OKMessage>
    </div>
  );
};

export default HireNewCreditLimit